<template>
    <v-dialog
            :value="showDialog"
            v-bind="dialogOptions"
            @input="startCloseTransition"
            @keydown.esc="startCloseTransition"
            content-class="sr-dialog"
    >
        <v-card>
            <component
                    :is="headerComponent"
                    v-bind="headerOptions"
                    :title="title"
                    :loading="loading"
                    @loading="loading = $event"
                    @confirmed="onConfirmed"
                    @canceled="startCloseTransition"
            />
            <component
                    :is="contentComponent"
                    ref="content"
                    v-bind="contentOptions"
                    :message="message"
                    :loading="loading"
                    @loading="loading = $event"
                    @confirmed="onConfirmed"
                    @canceled="startCloseTransition"
            />
            <component
                    :is="footerComponent"
                    v-bind="footerOptions"
                    :loading="loading"
                    @loading="loading = $event"
                    @confirmed="onConfirmed"
                    @canceled="startCloseTransition"
            />
        </v-card>
    </v-dialog>
</template>

<script>
  import DefaultContent from './content/Default.vue'
  import DefaultButtons from './button/Default.vue'
  import DefaultHeader from './header/Default.vue'
  import { VDialog } from 'vuetify/lib'

  export default {
    components: {
      VDialog
    },
    props: {
      dialog: {
        type: Object,
        required: true
      },
      title: {
        type: String
      },
      message: {
        type: String
      },
      dialogOptions: {
        type: Object
      },
      contentComponent: {
        default: () => DefaultContent
      },
      contentOptions: {
        type: Object
      },
      footerComponent: {
        default: () => DefaultButtons
      },
      footerOptions: {
        type: Object
      },
      headerComponent: {
        default: () => DefaultHeader
      },
      headerOptions: {
        type: Object
      },
      onConfirm: {
        type: Function
      },
      onConfirmError: {
        type: Function
      },
      closeOnError: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showDialog: false,
        loading: false,
        result: {
          confirmed: false,
          onConfirm: null,
          content: null
        }
      }
    },
    mounted () {
    },
    methods: {
      show () {
        this.showDialog = true
      },
      hide () {
        this.showDialog = false
      },
      startCloseTransition () {
        this.hide()
        // thanks vuetify ;)
        setTimeout(() => this.close(), 200)
      },
      close () {
        this.dialog.close()
      },
      async onConfirmed () {
        this.result.confirmed = true
        if (this.onConfirm) {
          this.loading = true
          let result
          try {
            result = await this.onConfirm(this.dialog)
          } catch (e) {
            if (this.onConfirmError) {
              await this.onConfirmError(this.dialog, e)
            }

            this.loading = false
            this.result.confirmed = false
            if (!this.closeOnError) {
              return
            }
          }

          this.result.onConfirm = result
          this.loading = false
        }
        this.result.content = this.dialog.contentData

        this.startCloseTransition()
      }
    }
  }
</script>
